module.exports = __webpack_public_path__ + "static/media/screen5.11e4e001.jpeg";